export const PUBLIC_PAGES = {
  SUBSCRIPTION: "/subscriptions",
  ORDER: "/order",
  PAYMENT_VERIFICATION: "/verify-payment",
  IOS: "/ios",
  IOS_HOME: "/ios/back",
  IOS_WHATSAPP: "/gethelp",
  ANDROID_HOME: "/back-to-app",
};
